import { activityFetcher } from './activity-fetcher'
import { correctGlobalActivityItems } from './global-sale-corrections'

export const correctedGlobalActivityFetcher = async (url: string) => {
	const data = await activityFetcher(url)
	return Array.isArray(data) ? correctGlobalActivityItems(data) : data
}
